import { render, staticRenderFns } from "./StockOpnameFormEdit.vue?vue&type=template&id=50763e77"
import script from "./StockOpnameFormEdit.vue?vue&type=script&lang=js"
export * from "./StockOpnameFormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports